

import showToaster from '../helpers/toasterMessages/showToaster';
import {
  UPDATE_CAR_DOCUMENT_STATUS_START,
  UPDATE_CAR_DOCUMENT_STATUS_SUCCESS,
  UPDATE_CAR_DOCUMENT_STATUS_ERROR
} from '../constants';

export const updateStatus = (listId, category, status, ids = undefined) => async (dispatch) => {
  dispatch({ type: UPDATE_CAR_DOCUMENT_STATUS_START });
  try {
    const response = await fetch('/graphql', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `
          mutation UpdateCarDocumentStatus($listId: Int!, $category: String, $status: String!, $ids: [Int]) {
            updateCarDocumentStatus(listId: $listId, category: $category, status: $status, ids: $ids) {
              id
              listId
              category
              status
            }
          }
        `,
        variables: { listId, category, status, ...(ids ? { ids } : {}) }
      })
    });

    const result = await response.json();

    if (result.data?.updateCarDocumentStatus) {
      dispatch({
        type: UPDATE_CAR_DOCUMENT_STATUS_SUCCESS,
        payload: result.data.updateCarDocumentStatus
      });
      showToaster({ messageId: 'carDocumentStatusSuccess', toasterType: 'success', requestMessage: 'Document status updated successfully!' });
      return result.data.updateCarDocumentStatus;
    } else {
      dispatch({
        type: UPDATE_CAR_DOCUMENT_STATUS_ERROR,
        error: result.errors || 'Failed to update document status'
      });
      showToaster({ messageId: 'carDocumentStatusFailed', toasterType: 'error', requestMessage: 'Failed to update document status. Please try again.' });
      return null;
    }
  } catch (error) {
    dispatch({
      type: UPDATE_CAR_DOCUMENT_STATUS_ERROR,
      error: error.message || 'Failed to update document status'
    });
    showToaster({ messageId: 'carDocumentStatusFailed', toasterType: 'error', requestMessage: 'Failed to update document status. Please try again.' });
    return null;
  }
};